module.exports = __webpack_public_path__ + "img/show-more.d632d842.svg";